<div class="modal-header">
  <h5 class="modal-title">Lieferscheineinstellungen</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <h6>Lieferscheinnummer:</h6>

  <input id="fileName" type="text" class="form-control" disabled [value]="fileName">

  <div class="filename-scheme" *ngIf="deliveryNoteSettings != null">
    <select id="fileNameFirstVariable" [disabled]="isSupporter"
            [(ngModel)]="deliveryNoteSettings.fileNameFirstVariable"
            class="form-select"
            (change)="setFileName()">
      <option value="sequentialNumber" [selected]="true">Fortlaufende Nummer</option>
      <option value="recipientLastName">Nachname</option>
      <option value="recipientFirstName">Vorname</option>
      <option value="createdMonth">Monat</option>
      <option value="createdYear">Jahr</option>
    </select>

    <select id="fileNameSecondVariable" [disabled]="isSupporter"
            [(ngModel)]="deliveryNoteSettings.fileNameSecondVariable"
            class="form-select"
            (change)="setFileName()">
      <option value=""></option>
      <option value="sequentialNumber">Fortlaufende Nummer</option>
      <option value="recipientLastName">Nachname</option>
      <option value="recipientFirstName">Vorname</option>
      <option value="createdMonth">Monat</option>
      <option value="createdYear">Jahr</option>
    </select>

    <select id="fileNameThirdVariable" [disabled]="isSupporter"
            [(ngModel)]="deliveryNoteSettings.fileNameThirdVariable"
            class="form-select"
            (change)="setFileName()">
      <option value=""></option>
      <option value="sequentialNumber">Fortlaufende Nummer</option>
      <option value="recipientLastName">Nachname</option>
      <option value="recipientFirstName">Vorname</option>
      <option value="createdMonth">Monat</option>
      <option value="createdYear">Jahr</option>
    </select>
  </div>
  <div class="pt-3 pl-4" *ngIf="deliveryNoteSettings != null">
    <div class="d-flex align-items-center">
      <input type="checkbox" [disabled]="isSupporter"
             id="deliveryNotesCreatedMonthly"
             [(ngModel)]="deliveryNoteSettings.isCreatedMonthly"
             [ngModelOptions]="{standalone: true}"
             class="form-check-input">
      <label for="deliveryNotesCreatedMonthly" class="form-check-label pt-1 ps-2" i18n="@@deliveryNotesCreatedMonthlyLabel">
        Lieferscheine für jeden Benutzer automatisch monatlich erstellen
      </label>
    </div>
  </div>
  </div>

  <div class="modal-footer">
    <div class="float-end">
      <button type="button" class="btn btn-yellow text-white me-2" data-bs-dismiss="modal" (click)="close()">
        Abbrechen
      </button>
      <button type="button" class="btn btn-save" data-bs-dismiss="modal" [disabled]="isSupporter" (click)="saveAndClose()">
        Änderungen speichern
      </button>
    </div>
  </div>

